/** 购买意向：以后端 /purchase-intents/meta 为准；此处仅作缺省与提交字段对齐。 */
export const PURCHASE_INTENT_STATUS = {
  PENDING: 'pending',
  IN_PROGRESS: 'in_progress',
  FULFILLED: 'fulfilled',
  FAILED: 'failed',
};

export const PURCHASE_INTENT_FAIL_REASON = {
  REJECTED_PLAN: 'rejected_plan',
  COMMUNICATION_FAILED: 'communication_failed',
};

export const PURCHASE_INTENT_LIMITS = {
  companyNameMin: 2,
  companyNameMax: 80,
  companyNamePattern: /^[\u4e00-\u9fff（）]+$/,
  companyNameCharsetMessage: '公司名称须为中文（可用中文括号），不能填写数字或英文',
  companyNameHint: '请填写工商登记的中文公司名，不要填数字或英文',
  contactNameMin: 2,
  contactNameMax: 20,
  contactPhonePattern: /^1[3-9]\d{9}$/,
  flagNoteMax: 50,
  failNoteMax: 200,
  itemsMax: 50,
};
